import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useContractState = () => React.useContext(Context)
export const useContract = () => useContractState()?.contract

const QUERY = gql`
  query Contract($id: ID) {
    contract(id: $id, filter: { includeDisabled: true, includeDeleted: true, ignoreSegments: true }) {
      id
      insertedAt
      deleted
      enabled
      user {
        id
        name
        email
        mobileDetails
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      profile {
        id
        name
        label
      }
      fieldValues {
        id
        value
        field {
          id
          name
          type
          configuration
        }
      }
    }
  }
`

const ContractLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: accountsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ContractLoader
